<template>
  <template v-if="curCols.length">
    <div class="xl-table" :ref="$attrs.ref || 'xlTableRefWrap'">
      <jw-table ref="xltable" :bordered="{ wrapper: false, headerCell: true }" v-bind="$attrs" :columns="showCol" size="large" @row-click="toInfoDetails" @column-resize="columnResize">
        <template v-for="(slot, slotName) in $slots" #[slotName]="slotProps" :key="slotName">
          <slot :name="slotName" v-bind="slotProps" />
        </template>
        <template #empty>
          <div class="xl-table-spin">
            <jw-empty v-if="!$attrs?.loading"></jw-empty>
          </div>
        </template>
      </jw-table>
    </div>
    <xl-col-select :key="uuid" :cols="cols" :k="key" :defcols="stateDefCol || {}" ref="tableColSelect" @cb="getCols"><span></span></xl-col-select>
  </template>
  <div class="xl-table-loading" v-else>
    <!-- <jw-empty>{{ $t('暂未配置表头，请先配置') }}</jw-empty> -->
    <jw-spin :loading="curCols?.length == 0" :style="{ width: '100%' }"></jw-spin>
  </div>
</template>
<!-- <script>
export default {
  inheritAttrs: false
};
</script> -->
<script setup>
import md5 from 'js-md5';
import { ref, computed, watchEffect, onMounted, useAttrs, onUnmounted } from 'vue';
// import { useStorage } from '@vueuse/core';
import CONFIG from '@/config/config';
const emits = defineEmits(['cbclick']);
const attrs = useAttrs();
const uuid = computed(() => attrs.uuid);
const stickyHeader = ref(attrs.stickyHeader ?? undefined);
const storage = {
  // localStorage
  setItem(key, value) {
    if (key && value) {
      const v = JSON.stringify(value);
      localStorage.setItem(key, v);
      return value;
    }
    return value;
  },
  getItem(key) {
    let v = localStorage.getItem(key);
    if (v !== 'null' && v !== undefined) {
      v = JSON.parse(v);
    }
    return v;
  },
  removeItem(key) {
    return localStorage.removeItem(key);
  }
};

const toInfoDetails = (value) => {
  emits('cbclick', value);
};

const props = defineProps({
  columns: {
    type: Array,
    default: () => [],
    validator(v) {
      if (v?.length === 0) {
        return true;
      }
      const dataIndex = v.reduce((prev, cur) => {
        const f = prev.includes(cur.dataIndex);
        if (!f) {
          prev.push(cur.dataIndex);
        }
        return prev;
      }, []);
      // The v must match one of these strings
      return dataIndex.length === v.length;
    }
  }
});
const curCols = computed(() => props.columns);
console.log('curCols', curCols);
// 获取当前显示的列
let c = curCols.value.filter((ele) => ele.colShow !== false);
// 要传给 列选择的所有列
const cols = ref([]);
cols.value = curCols.value.map((el) => ({ ...el }));
// 要存储到本地数据的列数据
// 生成唯一key
let uniqueKey = curCols.value.map((el) => el.dataIndex).join('') + curCols.value.length;
// let uniqueKey = curCols.value.map((el) => el.dataIndex.substr(0, 2)).join('') + curCols.value.length;
// 保存默认列和实际列
const tableKey = ref(`${CONFIG.prefix}TABLE_COLS_${attrs.uuid}_${md5(uniqueKey)}`);
// 2022-12-23 update 默认列
let defCols = curCols.value.reduce((prev, cur) => {
  const tmp = {};
  if (cur.width) tmp.width = cur.width;
  if (cur.fixed) tmp.fixed = cur.fixed;
  if (cur.colShow === false) tmp.colShow = cur.colShow;
  prev[cur.dataIndex] = tmp;
  return prev;
}, {});
let defColsSort = curCols.value.map((el) => el.dataIndex);
// 默认列的值
let kf = storage.getItem(tableKey.value) || { k: defCols, sort: defColsSort };
let kfDef = storage.getItem(`${tableKey.value}_DEFAULT`) || { k: defCols, sort: defColsSort };
// 设置的宽高
// let state = useStorage(key, curCols.value);
const state = ref(kf);
// 默认的顺序和宽高
const stateDefCol = ref(kfDef);
if (curCols.value.length) {
  state.value = storage.setItem(tableKey.value, kf);
  stateDefCol.value = storage.setItem(`${tableKey.value}_DEFAULT`, kfDef);
}
// 2022-12-23 update 默认列
// 要显示的列
const showCol = ref(c);
if (state.value) {
  const stateCols = state.value.sort.map((el) => {
    let tmp = {};
    const f = curCols.value.find((ele) => ele.dataIndex === el);
    if (f) {
      tmp = Object.assign({}, { ...f }, { ...state.value?.k[el] });
    }
    return tmp;
  });
  showCol.value = stateCols.filter((el) => el.colShow !== false);
  cols.value = stateCols;
}

watchEffect(() => {
  // 获取当前显示的列
  c = curCols.value.filter((ele) => ele.colShow !== false);
  // 要传给 列选择的所有列
  cols.value = curCols.value.map((el) => ({ ...el }));
  // 要存储到本地数据的列数据
  // 生成唯一key
  // uniqueKey = curCols.value.map((el) => el.dataIndex.substr(0, 2)).join('') + curCols.value.length;
  uniqueKey = curCols.value.map((el) => el.dataIndex).join('') + curCols.value.length;
  // 保存默认列和实际列
  tableKey.value = `${CONFIG.prefix}TABLE_COLS_${attrs.uuid}_${md5(uniqueKey)}`;
  // 2022-12-23 update 默认列
  defCols = curCols.value.reduce((prev, cur) => {
    const tmp = {};
    if (cur.width) tmp.width = cur.width;
    if (cur.fixed) tmp.fixed = cur.fixed;
    if (cur.colShow === false) tmp.colShow = cur.colShow;
    prev[cur.dataIndex] = tmp;
    return prev;
  }, {});
  defColsSort = curCols.value.map((el) => el.dataIndex);
  // 默认列的值
  kf = storage.getItem(tableKey.value) || { k: defCols, sort: defColsSort };
  kfDef = storage.getItem(`${tableKey.value}_DEFAULT`) || { k: defCols, sort: defColsSort };
  // 设置的宽高
  // state = useStorage(tableKey.value, curCols.value);
  if (curCols.value.length) {
    state.value = storage.setItem(tableKey.value, kf);
    stateDefCol.value = storage.setItem(`${tableKey.value}_DEFAULT`, kfDef);
  }
  // 2022-12-23 update 默认列
  // 要显示的列
  if (state.value) {
    const stateCols = state.value.sort.map((el) => {
      let tmp = {};
      const f = curCols.value.find((ele) => ele.dataIndex === el);
      if (f) {
        tmp = Object.assign({}, { ...f }, { ...state.value?.k[el] });
        if (!state.value?.k[el].fixed && tmp.fixed) {
          delete tmp.fixed;
        }
      }
      return tmp;
    });
    // showCol.value = stateCols.filter((el) => el.colShow !== false);
    const formatSortShowCol = [];
    stateCols
      .filter((el) => el.colShow !== false)
      .map((scv) => {
        if (attrs?.sortOrder?.dataIndex && attrs?.sortOrder?.dataIndex == scv.dataIndex) {
          scv.sortable['sortOrder'] = attrs?.sortOrder?.sortOrder;
        } else {
          if (scv.sortable?.sortOrder) delete scv.sortable?.sortOrder;
        }
        formatSortShowCol.push(scv);
      });
    showCol.value = formatSortShowCol;
    cols.value = stateCols;
  }
});
// 这是列选择相关代码 S
const tableColSelect = ref(null);
// const uuid = ref();
const openColSelect = () => {
  // uuid.value = uuid;
  tableColSelect.value.openDialog();
};
// 获取列选择的值
const getCols = (v) => {
  const c = v;
  const cf = c.filter((el) => el.colShow !== false);
  const kfc = {
    k: c.reduce((prev, cur) => {
      const tmp = {};
      if (cur.width) tmp.width = cur.width;
      if (cur.fixed) tmp.fixed = cur.fixed;
      if (cur.colShow === false) tmp.colShow = cur.colShow;
      prev[cur.dataIndex] = tmp;
      return prev;
    }, {}),
    sort: v.map((el) => el.dataIndex)
  };
  state.value = kfc;
  state.value = storage.setItem(tableKey.value, kfc);
  showCol.value = cf.map((el) => ({ ...el }));
};
// 这是列选择相关代码 E

// 调整列宽
let time = null;
const columnResize = (dataIndex, width) => {
  const s = storage.getItem(tableKey.value);
  if (s) {
    if (time) {
      clearTimeout(time);
      time = null;
    }
    time = setTimeout(() => {
      s.k[dataIndex].width = width;
      // const c = state.value.k.map((el) => {
      //   el = unref(el);
      //   if (el.dataIndex === dataIndex) {
      //     el.width = width;
      //   }
      //   return el;
      // });
      // state.value = c;
      state.value = storage.setItem(tableKey.value, s);
    }, 1000);
  }
};

const xltable = ref(null);
// 导出子组件
defineExpose({
  tableColSelect,
  xltable,
  openColSelect // 列选择的ref
});

// 给固定头设置样式
const doFix = (dom, top) => {
  dom.style.position = 'sticky';
  dom.style.zIndex = '100';
  dom.style.top = top + 'px';
};
// 给固定头取消样式
const removeFix = (dom) => {
  dom.style.position = 'static';
  dom.style.top = '0';
  dom.style.zIndex = '0';
};
const handleScroll = () => {
  const t = xltable.value?.$el;
  if (t) {
    const header = t.querySelector('.arco-table-header');
    const hdParent = header.parentNode;
    if (hdParent.className?.indexOf('arco-scrollbar arco-scrollbar-type-embed') > -1) {
      if (header.className?.indexOf('arco-table-header-sticky') > -1) {
        doFix(hdParent, stickyHeader.value);
      } else {
        removeFix(hdParent);
      }
    }
  }
  // header.className
};
onMounted(() => {
  // 如果有固定头部
  if (stickyHeader.value !== undefined) {
    // handleScroll();
    //页面卸载已移除监听 避免内存泄露
    window.addEventListener('scroll', handleScroll);
  }
});
onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll);
});
</script>
<!-- <script lang="jsx">
import { h, resolveComponent } from 'vue';
export default {
  inheritAttrs: false,
  setup(props, ctx) {
    const table = resolveComponent('jwTable');
    const t = h(table, { ...ctx.attrs }, { ...ctx.slots });
    return () => {
      return <div class="xl-table">{t}</div>;
    };
  }
};
</script> -->
<style scoped lang="less">
@import './xl-table.less';
</style>
